import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    userName: string;
    isGranting: boolean;
}

export default function ConfirmAdminChangeDialog(props: Props) {
    const handleConfirm = () => {
        props.onConfirm();
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>{props.isGranting ? 'Grant Admin Access?' : 'Revoke Admin Access?'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.isGranting
                        ? `Grant admin access to ${props.userName}? This will enable all permissions.`
                        : `Revoke admin access from ${props.userName}? This will disable all permissions and may remove their access to this page.`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color={props.isGranting ? 'primary' : 'error'}>
                    {props.isGranting ? 'Grant Admin' : 'Revoke Admin'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
